import { X } from "lucide-react";
import { SignaturePad } from "./SignaturePad";

export function SignatureModal({
  isOpen,
  value,
  onClose,
  onChange,
  onSave,
}: {
  isOpen: boolean;
  value: string;
  onClose: () => void;
  onChange: (signature: string) => void;
  onSave: (signature: string) => void;
}) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-sm mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Digital Signature</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-3">Please draw your signature in the box below:</p>
          <SignaturePad value={value} onChange={(v) => onChange(v)} />
        </div>
        <div className="flex gap-3 justify-end">
          <button onClick={onClose} className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50">
            Cancel
          </button>
          <button
            onClick={() => onSave(value)}
            disabled={!value}
            className="btn-primary text-sm disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            Save Signature
          </button>
        </div>
      </div>
    </div>
  );
}
